import { capitalize } from "lodash"
import { WHITELABEL } from "./constants"

function getWhiteLabel(lower = false) {
    const regex = new RegExp(`\\b(${WHITELABEL.whiteLabels.join('|')})\\b`)
    let whitelabel = window.location.href.match(regex) ? window.location.href.match(regex)[0] : 'cashforce'

    if(process.env.VUE_APP_ROOT_ENVIROMENT === "local"){
        whitelabel = process.env.VUE_APP_ROOT_USED_WHITELABEL
    }

    if (lower) return whitelabel

    if (whitelabel === 'fundomultisupermercados') return 'Fundo Multi Supermercados'
    if (whitelabel === 'osinteligenciafinanceira') return 'O.S. Inteligência Financeira'
    if (whitelabel === 'poenatela') return 'Põe na tela'
    if (whitelabel === 'iriom') return 'IRIOM'
    if (whitelabel === 'somospremium') return 'Somos Premium'
    if (whitelabel === 'amb') return 'AMB'
    if (whitelabel === 'mgpay') return 'MGpay'

    return capitalize(whitelabel)
}

export default getWhiteLabel